// ---------------------------------------------------------------------------
// management-view-api
//
// Frontend service wrapper for the Management View backend endpoints.
// Phase 0 ships only the bootstrap config endpoint — later phases will add
// matrix-data fetchers here.
//
// Per CLAUDE.md, the `api` wrapper prepends `/api` to every endpoint, so the
// strings passed in must NOT include the `/api` prefix.
// ---------------------------------------------------------------------------

import { api } from '@/lib/api';
import type { IApiResponse, IManagementViewConfig } from '@skystone/shared';

export const managementViewApi = {
  /**
   * `GET /api/management-view/config` — returns the visible tabs for the
   * authenticated caller's role plus Phase-0 filter defaults. Used by the
   * Management View page to drive its tab list and `FilterBar`.
   */
  getConfig: async (): Promise<IManagementViewConfig> => {
    const result = await api.get<IApiResponse<IManagementViewConfig>>(
      '/management-view/config',
    );
    return result.data;
  },
};
